import React, { SetStateAction } from 'react';
import cls from './DocumentSelect.module.css';
import { useDocumentSelect } from './useDocumentSelect';
import { Select } from '../../../../../../components/newUI/Select/Select';
import classNames from 'classnames';

interface DocumentSelectProps {
    classes?: string;
    errorStatus?: boolean;
    setErrorStatus: React.Dispatch<SetStateAction<boolean>>;
}

export const DocumentSelect = ({ classes, errorStatus, setErrorStatus }: DocumentSelectProps) => {
    const { documents, onSelect, selectedDocument } = useDocumentSelect({ setErrorStatus });

    return (
        <Select
            options={documents}
            placeholder={i18next.t('DocumentSelect.return.placeholder')}
            selected={selectedDocument}
            onChange={onSelect}
            classes={classNames(cls.Select, { [cls.ErrorSelect]: errorStatus })}
            notAbsolute
            widthClasses={cls.SelectWidth}
            colorClasses={cls.SelectText}
            placeholderClasses={classNames(cls.SelectPlaceholder, { [cls.Error]: errorStatus })}
            fullArrow={true}
        />
    );
};
